import './index.scss';
import { Router } from './router';
import { Layout } from './layout';
import { BrowserRouter } from 'react-router-dom';
import { Dispatch, createContext, useState } from 'react';

interface LoaderDataInterface {
  isLoading: boolean;
  title?: string;
}

interface LoaderInterface {
  loader: LoaderDataInterface;
  setLoader: Function;
}

const LoaderContext = createContext<LoaderInterface>({
  loader: {
    isLoading: false,
    title: '',
  },
  setLoader: () => {},
});

const App = () => {
  const [loader, setLoader] = useState({
    isLoading: false,
    title: '',
  });

  return (
    <LoaderContext.Provider value={{ loader, setLoader }}>
      <BrowserRouter>
        <Layout>
          <Router />
        </Layout>
      </BrowserRouter>
    </LoaderContext.Provider>
  );
};

export { App, LoaderContext };
